import { render } from "./project_management.html?vue&type=template&id=09b6598d&external"
import script from "./project_management.js?vue&type=script&lang=js&external"
export * from "./project_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__